module.exports = __webpack_public_path__ + "static/media/star-cereja.cce33729.jpg";